export const {
  MODE: environment,
  VITE_API_URL: ApiBaseUrl,
  VITE_INTERCOM_APP_ID: IntercomAppId,
  VITE_PADDLE_ENV: PaddleEnvironment,
  VITE_PADDLE_TOKEN: PaddleToken,
  VITE_POSTHOG_KEY: PostHogKey,
  VITE_POSTHOG_HOST: PostHogHost,
  VITE_PT_API_KEY: ProfitTreeApiKey,
  VITE_META_ADS_PIXEL_ID: MetaAdsPixelId,
  VITE_RELEASE_TAG: ReleaseTag,
} = import.meta.env
